export default {"src":"/_next/static/media/baby6.b1a4423e.svg","height":210,"width":210,"blurWidth":0,"blurHeight":0};